import { UntypedFormGroup } from '@angular/forms';

export enum MainFormEventType {
  LoadingCatalog = 'LoadingCatalog',
  LoadingRecord = 'LoadingRecord',
  FormReady = 'FormReady',
}

export interface MainFormEventMessage {
  form?: UntypedFormGroup;
  event: MainFormEventType;
}

export class MainFormEvent {
  private _form: UntypedFormGroup;
  private _event: MainFormEventType;
  constructor(payload: MainFormEventMessage) {
    this._form = payload.form;
    this._event = payload.event;
  }

  public get form() {
    return this._form;
  }
  public get eventName() {
    return this._event;
  }
}

export class MainFormEventFactory {
  public static LoadingCatalogEvent() {
    return new MainFormEvent({ form: null, event: MainFormEventType.LoadingCatalog });
  }
  public static LoadingRecordEvent() {
    return new MainFormEvent({ form: null, event: MainFormEventType.LoadingRecord });
  }
  public static FormReadyEvent(form: UntypedFormGroup) {
    return new MainFormEvent({ form, event: MainFormEventType.FormReady });
  }
}
